import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SEO from '@/components/seo/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <div className="container flex flex-col items-center justify-center min-h-[calc(100vh-16rem)] py-24 text-center">
      <SEO title="Page Not Found - LendLifted" description="404 Error: Page not found." />
      
      <div className="mb-8 rounded-full bg-slate-100 p-6">
        <Compass className="h-12 w-12 text-slate-400" strokeWidth={1.5} />
      </div>
      
      <h1 className="mb-6 font-sans text-5xl font-medium tracking-tight text-slate-900 md:text-7xl">
        Page not found
      </h1>
      
      <p className="mx-auto mb-10 max-w-lg text-xl leading-relaxed text-slate-600">
        The page you are looking for has moved or no longer exists. Head back to the homepage to continue.
      </p>
      
      <Button asChild size="lg" className="h-14 rounded-full bg-slate-900 px-8 text-lg text-white shadow-xl transition-all duration-300 hover:-translate-y-0.5 hover:bg-slate-800">
        <Link to="/">
          <Home className="mr-2 h-5 w-5" /> Return Homepage
        </Link>
      </Button>
    </div>
  );
};

export default NotFoundPage;
